import {
    Space,
    Button,
    Card,
    Select,
    useSelect,
} from "@pankod/refine-antd";
import { useApiUrl, useNotification } from "@pankod/refine-core";
import { BFF_KEY } from "environment";
import { IBranchOfficesSearch, BranchOffice } from "interfaces";
import { useState } from "react";
import { axiosInstance } from "services/axios";

type Props = {
    branchOffice?: BranchOffice;
    closeModal: () => void;
    refreshTable: () => void;
}

export const ModalBranchOfficeMunicipiesBind: React.FC<Props> = ({ branchOffice, closeModal, refreshTable }) => {
    const { selectProps } = useSelect<IBranchOfficesSearch>({
        resource: "v1/branch-office-place/list-by-desc",
        optionLabel: "PlaceDescription",
        optionValue: "Id",
        hasPagination: false,
        onSearch(value) {
            return [
                {
                    field: 'place_desc',
                    operator: 'eq',
                    value: value,
                }
            ]
        },
    });
    const [municipieId, setMunicipieId] = useState<number>();

    const toast = useNotification();
    const apiUrl = useApiUrl();
    const handleBindMunicipieToFilial = async () => {
        if (!municipieId) {
            toast.open?.({
                message: 'selecione um município para vincular a filial',
                type: 'error',
            });
            return;
        }
        try {
            await axiosInstance.put(
                `${apiUrl}/v1/branch-office-place/${municipieId}/update-areaid/${branchOffice?.AreaId}`,
                {},
                {
                    headers: {
                        'ocp-apim-subscription-key': BFF_KEY,
                    },
                }
            );
            toast.open?.({
                message: 'filial vinculada ao município com sucesso.',
                type: 'success',
            });
        } catch {
            toast.open?.({
                message: 'ocorreu um erro ao tentar vincular o município a filial selecionada, tente novamente mais tarde.',
                type: 'error',
            });
        } finally {
            refreshTable();
            closeModal();
        }
    };

    return (
        <>
            <Card title="Selecione um município">
                <Space>
                    <Select
                        {...selectProps}
                        onSelect={(data) => setMunicipieId(data as unknown as number)}
                        style={{ width: '30rem' }}
                    />
                    <Button
                        type="primary"
                        onClick={handleBindMunicipieToFilial}
                    >
                        Vincular
                    </Button>
                </Space>
            </Card>
        </>
    );
}
